// src/components/Email/EmailList.jsx
import React from 'react';
import EmailItem from './EmailItem';

export default function EmailList({ emails, onSelectEmail, selectedEmailId }) {
    if (emails.length === 0) {
        return (
            <div className="p-8 text-center text-gray-500">
                No emails found
            </div>
        );
    }

    return (
        <div className="overflow-y-auto h-full">
            {emails.map((email) => (
                <EmailItem
                    key={email.id}
                    email={email}
                    isSelected={email.id === selectedEmailId}
                    onClick={() => onSelectEmail(email)}
                />
            ))}
        </div>
    );
}